<div class="flex flex-column gap-3 border-1 border-round-lg p-3 border-bluegray-200" style="background-color: #F9FBFD;">
  <b class="text-left font-bold text-base">{{'Question : '+ essay.question }}</b>
  <div class="w-full border-round-lg border-1 border-bluegray-200">
    <div class="w-full text-left flex align-items-center justify-content-between border-round-lg border-noround-bottom border-bottom-1 border-bluegray-200 py-2 px-3 bg-blue-50 text-bluegray-300 text-base font-normal">
      <b
      class="w-auto text-left bg-blue-50 text-bluegray-300 text-base font-normal">
      {{ wordCount }} / {{wordLimit}} words
    </b>
    <p-button label="Recent Submissions" styleClass="recent-submission" [loading]="isLoadingPastSubmssions"
      (onClick)="getRecentSubmissions()"></p-button>
    </div>
    
    <app-content-editor [htmlContent]="initialContent" (onContentChange)="onEssayContentChange($event)">
    </app-content-editor>
  </div>
  <small class="ng-dirty ng-invalid text-red-500" *ngIf="submitted && !essay.answer">
    Content is required
  </small>
  <!-- Submit Button -->
  <div class="w-full flex align-items-center justify-content-center">
    <p-button label="Send to Mentor" [loading]="isLoading" styleClass="sendMentor" type="button" (onClick)="onSubmit()">
    </p-button>
  </div>
  <div class="w-full flex flex-column mt-3 " *ngIf="commentList.length > 0">
    <b class="w-full p-3" style="border-radius: 8px 8px 0 0; font-size: 20px; background-color: #EDF2F9; border: 1px solid #B1C2D9;">Suggestions</b>
    <div class="w-full p-3 flex  flex-column gap-3" style="border-radius: 0 0 8px 8px; background-color: #F6F9FE; border: 1px solid #B1C2D9; border-top: none;">
      <div class="w-full flex flex-column gap-2">
        @for(comment of commentList; track comment){
          <div class="w-full flex flex-column gap-2 p-3 bg-white" style="border: 1px solid #CCD7E7; border-radius: 4px;">
              <div class="w-full flex  gap-2 justify-content-between">
                <b class="w-full text-left font-medium" style="color: #000;">{{comment.selectedText}}</b>
                <p-button (onClick)="updateCommentStatus(comment.id)" icon="pi pi-check-circle" class="flex-shrink-0" styleClass="markResolvedBtn"/>
              </div>
              <p  style="font-size: 14px; color: #3F414A;">{{comment.comment}}</p>
              <p class="pt-2 mt-2" style="border-top: 1px solid #CCD7E7; font-size: 13px; color: #898989;">{{comment.createdOn | date: 'MMM dd, yyyy'}}</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<p-dialog header="Past Submissions" [modal]="true" [(visible)]="visible" [style]="{ 'width': '99%', 'min-height': '99%' }">
  <app-recent-submissions class="w-full" [submissions]="pastSubmissions"></app-recent-submissions>
</p-dialog>
